import { format, parse } from 'date-fns'
import { DATE_FORMAT } from '@/config'

export function formatDate(date: string | Date | undefined): string {
  if (!date) return 'N/A'
  
  const dateObj = typeof date === 'string' ? new Date(date) : date
  return dateObj.toLocaleString('sr-RS', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

export function parseDate(dateStr: string | undefined | null): Date | null {
  if (!dateStr) {
    return null
  }

  try {
    if (dateStr.includes('/')) {
      const [day, month, year] = dateStr.split('/')
      return new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
    }
    return new Date(dateStr)
  } catch (e) {
    console.error('Error parsing date:', dateStr, e)
    return null
  }
} 